module.exports = __webpack_public_path__ + "img/points.0e754b2a.svg";